import { observer } from 'mobx-react-lite';
import React from 'react';
import AloDropdown, { DropdownItem } from '../YogaUI/alo-ui/AloDropdown';
import { FMSModalState, setBustFromUsersInput, setCupFromUsersInput, FMSModalStateShape } from './state';
import { getDropdownOptions, sizeChartData } from './utils';

const cupSizes = Object.keys(sizeChartData.women.bras).filter((size) => size.length === 1);
const bustSizes = Object.keys(sizeChartData.women.bras.a);

const dropdownOptions = {
  bust: getDropdownOptions(bustSizes),
  cup: getDropdownOptions(cupSizes),
};

let FindMySizeDropdowns = () => {
  return (
    <>
      <FMSDropdown
        dropdownOptions={dropdownOptions.bust.map(({ key, text }) => ({ key, text }))}
        options={{ title: 'Bust', placeholder: 'Select Bust', value: FMSModalState.bust }}
        onChangeCallback={(value: string) => {
          setBustFromUsersInput(value);
        }}
      />
      <FMSDropdown
        dropdownOptions={dropdownOptions.cup.map(({ key, text }) => ({ key, text }))}
        options={{ title: 'Cup', placeholder: 'Select Cup', value: FMSModalState.cup }}
        onChangeCallback={(value: string) => {
          setCupFromUsersInput(value);
        }}
      />
    </>
  );
};

FindMySizeDropdowns = observer(FindMySizeDropdowns);
export { FindMySizeDropdowns };

const FMSDropdown = ({
  dropdownOptions,
  onChangeCallback,
  options,
}: {
  dropdownOptions: DropdownItem[];
  onChangeCallback: (value: string) => void;
  options: FMSinputOptions;
}) => {
  const { title, placeholder } = options;
  const selectedValue = FMSModalState[title.toLowerCase() as keyof FMSModalStateShape] || '';

  return (
    <div className={`fms-dropdown-wrapper`}>
      <h3 className="cta">{title}</h3>
      <AloDropdown
        placeholder={placeholder}
        wrapperClass="fms-dropdown"
        defaultValue={{
          key: selectedValue,
          text: selectedValue,
        }}
        dropdownItems={dropdownOptions}
        onChange={({ key }) => {
          onChangeCallback(key);
        }}
      />
    </div>
  );
};

interface FMSinputOptions {
  title: string;
  placeholder: string;
  value: string | null;
}
